import Vue from "vue";
import App from "./Root.vue";
import Buefy from "buefy";
import Vue2TouchEvents from "vue2-touch-events";
import "buefy/dist/buefy.css";
import Root from './Root.vue';
import router from './router';

Vue.use(Vue2TouchEvents);
Vue.use(Buefy);

new Vue({
  router,
  render: h => h(Root)
}).$mount("#app");